import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/client';
import { useWebSocket } from '../../api/websocket';

export default function PromosList() {
  const [promos, setPromos] = useState([]);
  const [loading, setLoading] = useState(true);
  const { lastMessage } = useWebSocket('/ws/promos');

  useEffect(() => {
    loadPromos();
  }, [lastMessage]);

  async function loadPromos() {
    try {
      const res = await api.get('/api/promos');
      setPromos(res.data);
    } catch (err) {
      console.error('Failed to load promos', err);
    } finally {
      setLoading(false);
    }
  }

  const toggleActive = async (id) => {
    try {
      await api.put(`/api/promos/${id}/toggle`);
      loadPromos();
    } catch (err) {
      console.error('Failed to toggle promo', err);
    }
  };

  if (loading) return <div className="p-6">Loading...</div>;

  return (
    <div className="p-6">
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-2xl font-bold text-dark-100">Promos</h1>
        <Link to="/promos/create" className="btn btn-primary">Add New</Link>
      </div>
      <div className="table-wrapper">
        <table className="table">
          <thead>
            <tr>
              <th>Name</th><th>Time</th><th>Day</th><th>Date Range</th><th>Frequency</th><th>Priority</th><th>Status</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {promos.map(p => (
              <tr key={p.id}>
                <td>{p.name}</td>
                <td>{p.trigger_time || '-'}</td>
                <td>{p.trigger_day || '-'}</td>
                <td>{p.start_date} - {p.end_date}</td>
                <td>
                  {p.frequency_minutes ? `${p.frequency_minutes}m` : ''}
                  {p.frequency_songs ? `${p.frequency_songs} songs` : ''}
                </td>
                <td>{p.priority}</td>
                <td>
                  <span className={`badge ${p.is_active ? 'badge-success' : 'badge-neutral'}`}>
                    {p.is_active ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td>
                  <button onClick={() => toggleActive(p.id)} className="btn btn-sm btn-outline">
                    {p.is_active ? 'Deactivate' : 'Activate'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
